import { Message } from "../../../../../models"

export const proccessSingleMessageResponse = (response: Message): Message => {
    const cloneResponse = { ...response }

    return {
        ...cloneResponse,
        tempId: response.tempId ?? null
    }
}

export const processMessagesResponse = (messagesResponse: Message[]): Message[] => {
    return messagesResponse.map(proccessSingleMessageResponse)
}